'use client';
import React, {HTMLAttributes} from 'react';
import NavBreadcrumb from '../../NavBreadcrumb';
import {ICategoryDictionary} from '@/dictionaries/pages/category/types';
import {usePathname} from 'next/navigation';

interface ICustomBreadcrumbProps extends HTMLAttributes<HTMLDivElement> {
  lang: string;
  dict: ICategoryDictionary;
  categoryTitle: string;
}

export const CustomBreadcrumb: React.FC<ICustomBreadcrumbProps> = ({
  lang,
  dict,
  categoryTitle,
}) => {
  const pathname = usePathname();

  return (
    <NavBreadcrumb.Root>
      <NavBreadcrumb.Item path={lang === 'en' ? '/' : `/${lang}`}>
        {dict.breadcrumbHome}
      </NavBreadcrumb.Item>
      {/* <NavBreadcrumb.Item
      // path="/sicily/experiences/villas"
      >
        {dict.breadcrumbVillas}
      </NavBreadcrumb.Item> */}
      <NavBreadcrumb.Item
        path={pathname.substring(0, pathname.lastIndexOf('/'))}>
        {dict.breadcrumbExperiences}
      </NavBreadcrumb.Item>
      <NavBreadcrumb.Item>{categoryTitle}</NavBreadcrumb.Item>
    </NavBreadcrumb.Root>
  );
};
